module.exports = __webpack_public_path__ + "components/page-footer/static/mountain-forecast__logo--white-1fd14abf3576a073cd5235de88ab22ba.png";